import { PHONE, locationSchema } from "../structured-data-core";

export function getBostonStructuredData() {
  const url = "https://restorehair.com/locations/massachusetts/boston/";
  const description =
    "Find out about your hair transplant options in Boston with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Boston", "75 Arlington Street, Suite 500", "Boston", "MA", PHONE, url, description),
  ];
}
